// extracted by mini-css-extract-plugin
export default {"partnersGrid":"Section2_partnersGrid__Io2aw","partnerItem":"Section2_partnerItem__qQIVs","partnerImage":"Section2_partnerImage__2o2Ef"};